/* The Call — v4 theme JS */
(function () {
  'use strict';

  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener('click', function (event) {
        var target = document.querySelector(anchor.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      });
    });
  }

  function ensurePasswordGate() {
    var gate = document.getElementById('password-gate');
    if (gate) return gate;

    var main = document.getElementById('main-content');
    if (!main || !main.parentNode) return null;

    gate = document.createElement('section');
    gate.className = 'password-gate password-gate--js';
    gate.id = 'password-gate';
    gate.setAttribute('role', 'region');
    gate.setAttribute('aria-label', 'Store password');
    gate.innerHTML =
      '<div class="password-gate-inner">' +
        '<p class="password-gate-copy">Enter the store password to view product pages.</p>' +
        '<form method="post" action="/password" id="password-gate-form" accept-charset="UTF-8" class="password-gate-form storefront-password-form">' +
          '<input type="hidden" name="form_type" value="storefront_password">' +
          '<input type="hidden" name="utf8" value="✓">' +
          '<input type="hidden" name="return_url" value="/password" data-password-return>' +
          '<label class="visually-hidden" for="password-gate-input">Store password</label>' +
          '<input id="password-gate-input" class="password-gate-input" type="password" name="password" placeholder="Store password" autocomplete="current-password" required>' +
          '<button type="submit" class="password-gate-btn">Enter</button>' +
        '</form>' +
      '</div>';

    main.parentNode.insertBefore(gate, main);
    return gate;
  }

  function initPasswordProductLinks() {
    if (document.querySelector('[data-email-landing]')) return;
    if (document.body.classList.contains('template-landing')) return;
    if (!document.body.classList.contains('template-password')) return;

    var gate = ensurePasswordGate();
    var form = document.getElementById('password-gate-form');
    var returnInput = form && form.querySelector('[data-password-return]');
    var passwordInput = document.getElementById('password-gate-input');
    if (!gate || !form || !returnInput) return;

    function openGateForProduct(href) {
      returnInput.value = href;
      gate.classList.add('password-gate--visible');
      gate.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (passwordInput) {
        window.setTimeout(function () {
          passwordInput.focus();
        }, 350);
      }
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href*="/products/"]');
      if (!link) return;

      var href = link.getAttribute('href');
      if (!href || href.indexOf('/products/') === -1) return;

      event.preventDefault();
      event.stopPropagation();
      openGateForProduct(href);
    }, true);
  }

  function initNavStatesBg() {
    var nav = document.querySelector('.site-nav');
    var states = document.getElementById('states');
    if (!nav || !states) return;

    function update() {
      var navH = nav.offsetHeight;
      var rect = states.getBoundingClientRect();
      var onStates = rect.top <= navH && rect.bottom > 0;
      nav.classList.toggle('nav--on-states', onStates);
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
  }

  function initFaqAccordion() {
    document.querySelectorAll('.faq-list, .pdp-qa-list').forEach(function (list) {
      var items = list.querySelectorAll('.faq-item');
      if (!items.length) return;

      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    });
  }

  function initSocialGallery() {
    document.querySelectorAll('[data-social-gallery]').forEach(function (root) {
      var track = root.querySelector('[data-social-track]');
      var prev = root.querySelector('[data-social-prev]');
      var next = root.querySelector('[data-social-next]');
      if (!track || !prev || !next) return;

      function scrollStep(dir) {
        var card = track.querySelector('.social-card');
        if (!card) return;
        var gap = parseFloat(getComputedStyle(track).gap) || 16;
        track.scrollBy({ left: dir * (card.offsetWidth + gap), behavior: 'smooth' });
      }

      function updateArrows() {
        var maxScroll = track.scrollWidth - track.clientWidth;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maxScroll - 2;
      }

      prev.addEventListener('click', function () { scrollStep(-1); });
      next.addEventListener('click', function () { scrollStep(1); });
      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function initProductGallery() {
    var gallery = document.querySelector('[data-pdp-gallery]');
    if (!gallery) return;

    var mainWrap = gallery.querySelector('[data-gallery-main-wrap]');
    var main = gallery.querySelector('[data-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    if (!main || !mainWrap || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-gallery-src');
        if (!src) return;
        main.src = src;
        var isPackage = thumb.getAttribute('data-gallery-package') === 'true';
        mainWrap.classList.toggle('pdp-gallery-main--package', isPackage);
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
      });
    });
  }

  function initProductPage() {
    var root = document.querySelector('[data-pdp]');
    var dataEl = document.getElementById('pdp-data');
    if (!root || !dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var form = root.querySelector('[data-product-form]');
    var toggleBtns = root.querySelectorAll('[data-purchase-type]');
    var planPanel = root.querySelector('[data-subscription-panel]');
    var perks = root.querySelector('[data-subscription-perks]');
    var perkShipping = root.querySelector('[data-perk-shipping]');
    var planInput = root.querySelector('[data-selling-plan-input]');
    var planRadios = root.querySelectorAll('[data-selling-plan-radio]');
    var priceCurrent = root.querySelector('[data-price-current]');
    var priceCompare = root.querySelector('[data-price-compare]');
    var saveBadge = root.querySelector('[data-save-badge]');
    var ctaSubscribe = root.querySelector('[data-cta-subscribe]');
    var ctaOnetime = root.querySelector('[data-cta-onetime]');
    var mode = 'subscription';

    function getCheckedRadio() {
      return root.querySelector('[data-selling-plan-radio]:checked');
    }

    function getActivePlanDetails() {
      var checked = getCheckedRadio();
      if (data.hasSubscription) {
        if (checked) {
          return {
            price: parseInt(checked.getAttribute('data-plan-price'), 10),
            saveAmount: parseInt(checked.getAttribute('data-save-amount'), 10) || 0,
            freeShipping: checked.getAttribute('data-free-shipping') === 'true'
          };
        }
        if (data.plans.length) {
          return {
            price: data.plans[0].price,
            saveAmount: data.plans[0].saveAmount || (data.oneTimePrice - data.plans[0].price),
            freeShipping: false
          };
        }
      }

      if (checked) {
        return {
          price: parseInt(checked.getAttribute('data-plan-price'), 10),
          saveAmount: parseInt(checked.getAttribute('data-save-amount'), 10) || 0,
          freeShipping: checked.getAttribute('data-free-shipping') === 'true'
        };
      }

      if (data.demoPlans && data.demoPlans.length) {
        return {
          price: data.demoPlans[0].price,
          saveAmount: data.demoPlans[0].saveAmount,
          freeShipping: data.demoPlans[0].freeShipping
        };
      }

      return {
        price: Math.round(data.oneTimePrice * 0.9),
        saveAmount: Math.round(data.oneTimePrice * 0.1),
        freeShipping: false
      };
    }

    function updateUI() {
      var isSub = mode === 'subscription';
      toggleBtns.forEach(function (btn) {
        var active = btn.getAttribute('data-purchase-type') === mode;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      if (planPanel) planPanel.hidden = !isSub;
      if (perks) perks.hidden = !isSub;

      if (isSub) {
        var plan = getActivePlanDetails();
        if (priceCurrent) priceCurrent.textContent = formatMoney(plan.price);
        if (priceCompare) {
          priceCompare.hidden = false;
          priceCompare.textContent = data.oneTimePriceFormatted || formatMoney(data.oneTimePrice);
        }
        if (saveBadge) {
          saveBadge.hidden = false;
          saveBadge.textContent = plan.saveAmount > 0
            ? 'Save ' + formatMoney(plan.saveAmount)
            : 'Save';
        }
        if (perkShipping) {
          perkShipping.hidden = !plan.freeShipping;
        }
        if (planInput && data.hasSubscription) {
          planInput.disabled = false;
          var checked = getCheckedRadio();
          if (checked) planInput.value = checked.value;
        } else if (planInput) {
          planInput.disabled = true;
        }
        if (ctaSubscribe) ctaSubscribe.hidden = false;
        if (ctaOnetime) ctaOnetime.hidden = true;
      } else {
        if (priceCurrent) {
          priceCurrent.textContent = data.oneTimePriceFormatted || formatMoney(data.oneTimePrice);
        }
        if (priceCompare) priceCompare.hidden = true;
        if (saveBadge) saveBadge.hidden = true;
        if (perkShipping) perkShipping.hidden = true;
        if (planInput) {
          planInput.disabled = true;
          planInput.removeAttribute('name');
        }
        if (ctaSubscribe) ctaSubscribe.hidden = true;
        if (ctaOnetime) ctaOnetime.hidden = false;
      }

      if (isSub && planInput && data.hasSubscription) {
        planInput.setAttribute('name', 'selling_plan');
      }
    }

    toggleBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        mode = btn.getAttribute('data-purchase-type');
        updateUI();
      });
    });

    planRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        planRadios.forEach(function (r) {
          r.closest('.pdp-plan').classList.toggle('is-selected', r.checked);
        });
        if (planInput) planInput.value = radio.value;
        updateUI();
      });
    });

    if (form && planInput && !data.hasSubscription) {
      form.addEventListener('submit', function () {
        if (mode === 'onetime') planInput.removeAttribute('name');
      });
    }

    updateUI();
  }

  function initHeroHeadlineCycle() {
    var midCycle = document.querySelector('[data-hero-cycle="mid"]');
    var endCycle = document.querySelector('[data-hero-cycle="end"]');
    if (!midCycle || !endCycle) return;

    var midItems = midCycle.querySelectorAll('span:not(.hero-title-cycle-size)');
    var endItems = endCycle.querySelectorAll('span:not(.hero-title-cycle-size)');
    if (!midItems.length || midItems.length !== endItems.length) return;

    var index = 0;
    var total = midItems.length;

    function setActive(next) {
      midItems.forEach(function (item, i) {
        item.classList.toggle('is-active', i === next);
      });
      endItems.forEach(function (item, i) {
        item.classList.toggle('is-active', i === next);
      });
    }

    window.setInterval(function () {
      index = (index + 1) % total;
      setActive(index);
    }, 2200);
  }

  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer && window.TheCallPreview) {
      drawer = buildPreviewCartDrawer();
    }
    if (!drawer) return;

    var itemsEl = drawer.querySelector('[data-cart-items]');
    var emptyEl = drawer.querySelector('[data-cart-empty]');
    var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    var upsellWrap = drawer.querySelector('[data-cart-upsell]');
    var upsellTrack = drawer.querySelector('[data-cart-upsell-track]');
    var upsellDots = drawer.querySelector('[data-cart-upsell-dots]');
    var checkoutBtn = drawer.querySelector('[data-cart-checkout]');
    var notesToggle = drawer.querySelector('[data-cart-notes-toggle]');
    var notesPanel = drawer.querySelector('[data-cart-notes]');
    var noteInput = drawer.querySelector('[data-cart-note]');
    var countEls = document.querySelectorAll('[data-cart-count]');
    var upsellData = [];
    var upsellIndex = 0;
    var previewCart = null;
    var noteTimer = null;
    var lastCart = null;

    var upsellScript = document.getElementById('cart-upsell-data');
    if (upsellScript) {
      try {
        upsellData = JSON.parse(upsellScript.textContent);
      } catch (e) {
        upsellData = [];
      }
    }

    function assetBase() {
      return window.TheCallAssetBase || 'assets/';
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function getDefaultPreviewCart() {
      var base = assetBase();
      return {
        item_count: 3,
        note: '',
        items_subtotal_price: 6750,
        original_total_price: 7500,
        total_discount: 750,
        items: [
          {
            key: 'preview-connect',
            product_id: 'connect',
            title: 'Call to Connect Strips',
            variant_title: '3 every 3 months',
            quantity: 3,
            image: base + 'brand-connect.png',
            url: '#',
            original_line_price: 7500,
            final_line_price: 6750,
            line_level_discount_allocations: [{ amount: 750 }]
          }
        ]
      };
    }

    function getPreviewCart() {
      if (!previewCart) previewCart = getDefaultPreviewCart();
      return JSON.parse(JSON.stringify(previewCart));
    }

    function setPreviewCart(cart) {
      previewCart = cart;
      return cart;
    }

    function fetchCart() {
      if (window.TheCallPreview) {
        return Promise.resolve(getPreviewCart());
      }
      return fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(function (res) {
        if (!res.ok) throw new Error('cart fetch failed');
        return res.json();
      });
    }

    function updateCounts(count) {
      countEls.forEach(function (el) {
        el.textContent = String(count);
      });
    }

    function lineSave(item) {
      var diff = item.original_line_price - item.final_line_price;
      return diff > 0 ? diff : 0;
    }

    function renderItems(cart) {
      if (!itemsEl) return;

      if (!cart.items.length) {
        itemsEl.innerHTML = '';
        if (emptyEl) emptyEl.hidden = false;
        if (upsellWrap) upsellWrap.hidden = true;
        if (checkoutBtn) checkoutBtn.disabled = true;
        return;
      }

      if (emptyEl) emptyEl.hidden = true;
      if (checkoutBtn) checkoutBtn.disabled = false;

      itemsEl.innerHTML = cart.items.map(function (item) {
        var save = lineSave(item);
        var img = item.image || (item.featured_image && item.featured_image.url) || '';
        var title = item.product_title || item.title || 'Product';
        var variant = item.variant_title && item.variant_title !== 'Default Title'
          ? item.variant_title
          : '';
        var compareHtml = save > 0
          ? '<span class="cart-drawer-item-compare">' + formatMoney(item.original_line_price) + '</span>'
          : '';
        var saveHtml = save > 0
          ? '<span class="cart-drawer-item-save">(Save ' + formatMoney(save) + ')</span>'
          : '';

        return (
          '<article class="cart-drawer-item" data-cart-line="' + item.key + '">' +
            '<img class="cart-drawer-item-img" src="' + img + '" alt="" loading="lazy">' +
            '<div class="cart-drawer-item-body">' +
              '<a class="cart-drawer-item-title" href="' + (item.url || '#') + '">' + title + '</a>' +
              (variant ? '<p class="cart-drawer-item-variant">' + variant + '</p>' : '') +
            '</div>' +
            '<div class="cart-drawer-item-side">' +
              '<button type="button" class="cart-drawer-item-remove" data-cart-remove="' + item.key + '" aria-label="Remove ' + title + '">' +
                '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
                  '<path d="M3 4h10M6 4V3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1m2 0v9a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4h8z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>' +
                '</svg>' +
              '</button>' +
              '<div class="cart-drawer-item-prices">' +
                '<div class="cart-drawer-item-price-row">' +
                  compareHtml +
                  '<span class="cart-drawer-item-price">' + formatMoney(item.final_line_price) + '</span>' +
                '</div>' +
                saveHtml +
              '</div>' +
            '</div>' +
          '</article>'
        );
      }).join('');

      itemsEl.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          removeLine(btn.getAttribute('data-cart-remove'));
        });
      });
    }

    function renderSubtotal(cart) {
      if (!subtotalEl) return;
      var original = cart.original_total_price || cart.items_subtotal_price;
      var current = cart.items_subtotal_price;
      var hasDiscount = original > current;

      subtotalEl.innerHTML =
        (hasDiscount ? '<span class="cart-drawer-subtotal-compare">' + formatMoney(original) + '</span>' : '') +
        '<span class="cart-drawer-subtotal-current">' + formatMoney(current) + '</span>';
    }

    function cartProductIds(cart) {
      return cart.items.map(function (item) {
        return String(item.product_id || item.title || '').toLowerCase();
      });
    }

    function renderUpsell(cart) {
      if (!upsellTrack || !upsellWrap) return;

      var inCart = cartProductIds(cart);
      var slides = upsellData.filter(function (product) {
        return inCart.indexOf(String(product.id).toLowerCase()) === -1 &&
          inCart.join(' ').indexOf(product.title.toLowerCase()) === -1;
      });

      if (!slides.length || !cart.items.length) {
        upsellWrap.hidden = true;
        return;
      }

      upsellWrap.hidden = false;
      upsellIndex = Math.min(upsellIndex, slides.length - 1);

      upsellTrack.innerHTML = slides.map(function (product, i) {
        return (
          '<div class="cart-drawer-upsell-slide" data-upsell-slide="' + i + '">' +
            '<img class="cart-drawer-upsell-img" src="' + product.image + '" alt="">' +
            '<div class="cart-drawer-upsell-info">' +
              '<p class="cart-drawer-upsell-name">' + product.title + '</p>' +
              '<p class="cart-drawer-upsell-price">' + product.price + '</p>' +
            '</div>' +
            '<button type="button" class="cart-drawer-upsell-add" data-upsell-add="' + product.id + '">Add</button>' +
          '</div>'
        );
      }).join('');

      if (upsellDots) {
        upsellDots.innerHTML = slides.map(function (_, i) {
          return '<button type="button" class="cart-drawer-upsell-dot' + (i === upsellIndex ? ' is-active' : '') + '" data-upsell-dot="' + i + '" aria-label="Show product ' + (i + 1) + '"></button>';
        }).join('');
      }

      upsellTrack.style.width = (slides.length * 100) + '%';
      upsellTrack.style.transform = 'translateX(-' + ((upsellIndex * 100) / slides.length) + '%)';

      upsellTrack.querySelectorAll('[data-upsell-add]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          addUpsell(btn.getAttribute('data-upsell-add'));
        });
      });

      if (upsellDots) {
        upsellDots.querySelectorAll('[data-upsell-dot]').forEach(function (dot) {
          dot.addEventListener('click', function () {
            upsellIndex = parseInt(dot.getAttribute('data-upsell-dot'), 10) || 0;
            if (lastCart) renderUpsell(lastCart);
          });
        });
      }
    }

    function renderCart(cart) {
      lastCart = cart;
      updateCounts(cart.item_count);
      renderItems(cart);
      renderSubtotal(cart);
      renderUpsell(cart);
      if (noteInput && cart.note !== undefined && document.activeElement !== noteInput) {
        noteInput.value = cart.note || '';
      }
    }

    function removeLine(key) {
      if (window.TheCallPreview) {
        var cart = getPreviewCart();
        cart.items = cart.items.filter(function (item) { return item.key !== key; });
        cart.item_count = cart.items.reduce(function (sum, item) { return sum + item.quantity; }, 0);
        cart.items_subtotal_price = cart.items.reduce(function (sum, item) { return sum + item.final_line_price; }, 0);
        cart.original_total_price = cart.items.reduce(function (sum, item) { return sum + item.original_line_price; }, 0);
        cart.total_discount = cart.original_total_price - cart.items_subtotal_price;
        setPreviewCart(cart);
        renderCart(cart);
        return;
      }

      fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
        .then(function (res) { return res.json(); })
        .then(renderCart)
        .catch(function () {});
    }

    function addUpsell(productId) {
      var product = upsellData.find(function (p) { return p.id === productId; });
      if (!product) return;

      if (window.TheCallPreview) {
        var cart = getPreviewCart();
        var price = parseInt(String(product.price).replace(/[^0-9]/g, ''), 10) || 2500;
        cart.items.push({
          key: 'preview-' + productId + '-' + Date.now(),
          product_id: productId,
          title: product.title,
          variant_title: 'One-time purchase',
          quantity: 1,
          image: product.image,
          url: product.url || '#',
          original_line_price: price,
          final_line_price: price,
          line_level_discount_allocations: []
        });
        cart.item_count = cart.items.reduce(function (sum, item) { return sum + item.quantity; }, 0);
        cart.items_subtotal_price = cart.items.reduce(function (sum, item) { return sum + item.final_line_price; }, 0);
        cart.original_total_price = cart.items.reduce(function (sum, item) { return sum + item.original_line_price; }, 0);
        setPreviewCart(cart);
        renderCart(cart);
        return;
      }

      fetch(product.url + '.js')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var variant = data.variants && data.variants[0];
          if (!variant) return;
          return fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: variant.id, quantity: 1 })
          });
        })
        .then(function () { return fetchCart(); })
        .then(renderCart)
        .catch(function () {});
    }

    function saveNote(value) {
      if (window.TheCallPreview) {
        var cart = getPreviewCart();
        cart.note = value;
        setPreviewCart(cart);
        return;
      }

      fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: value })
      }).catch(function () {});
    }

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer-open');
      fetchCart().then(renderCart).catch(function () {
        if (window.TheCallPreview) renderCart(getPreviewCart());
      });
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-drawer-open');
    }

    document.querySelectorAll('[data-cart-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        openDrawer();
      });
    });

    drawer.querySelectorAll('[data-cart-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    if (notesToggle && notesPanel) {
      notesToggle.addEventListener('click', function () {
        var open = notesPanel.hidden;
        notesPanel.hidden = !open;
        if (open && noteInput) noteInput.focus();
      });
    }

    if (noteInput) {
      noteInput.addEventListener('input', function () {
        window.clearTimeout(noteTimer);
        noteTimer = window.setTimeout(function () {
          saveNote(noteInput.value);
        }, 400);
      });
    }

    fetchCart().then(renderCart).catch(function () {
      if (window.TheCallPreview) renderCart(getPreviewCart());
    });

    window.TheCallCart = {
      open: openDrawer,
      close: closeDrawer,
      refresh: function () {
        return fetchCart().then(renderCart);
      }
    };
  }

  function buildPreviewCartDrawer() {
    var base = assetBaseForPreview();
    var root = document.createElement('div');
    root.innerHTML =
      '<div class="cart-drawer" data-cart-drawer aria-hidden="true">' +
        '<div class="cart-drawer-overlay" data-cart-close tabindex="-1" aria-hidden="true"></div>' +
        '<aside class="cart-drawer-panel" role="dialog" aria-modal="true" aria-labelledby="cart-drawer-title">' +
          '<header class="cart-drawer-header">' +
            '<h2 class="cart-drawer-title" id="cart-drawer-title">Cart (<span data-cart-count>0</span>)</h2>' +
            '<button type="button" class="cart-drawer-close" data-cart-close aria-label="Close cart">' +
              '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="M4 4l10 10M14 4L4 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
            '</button>' +
          '</header>' +
          '<div class="cart-drawer-banner" aria-hidden="true"><div class="cart-drawer-banner-inner">' +
            '<span>Free shipping over $120</span><span>Free shipping over $120</span>' +
            '<span>Free shipping over $120</span><span>Free shipping over $120</span>' +
          '</div></div>' +
          '<div class="cart-drawer-body">' +
            '<div class="cart-drawer-items" data-cart-items></div>' +
            '<div class="cart-drawer-empty" data-cart-empty hidden><p>Your cart is empty.</p>' +
              '<button type="button" class="cart-drawer-continue" data-cart-close>Continue shopping</button></div>' +
            '<button type="button" class="cart-drawer-notes-toggle" data-cart-notes-toggle>' +
              '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M2.5 11.5l1.2-3.4 6.1-6.1a1 1 0 0 1 1.4 0l1.3 1.3a1 1 0 0 1 0 1.4l-6.1 6.1-3.4 1.2z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/></svg>' +
              'Add special instructions</button>' +
            '<div class="cart-drawer-notes" data-cart-notes hidden>' +
              '<label class="visually-hidden" for="cart-note">Special instructions</label>' +
              '<textarea id="cart-note" rows="3" placeholder="Add a note to your order" data-cart-note></textarea>' +
            '</div>' +
          '</div>' +
          '<div class="cart-drawer-upsell" data-cart-upsell>' +
            '<div class="cart-drawer-upsell-head">' +
              '<p class="cart-drawer-upsell-title">You might also like</p>' +
              '<div class="cart-drawer-upsell-dots" data-cart-upsell-dots aria-hidden="true"></div>' +
            '</div>' +
            '<div class="cart-drawer-upsell-track-wrap"><div class="cart-drawer-upsell-track" data-cart-upsell-track></div></div>' +
          '</div>' +
          '<footer class="cart-drawer-footer">' +
            '<div class="cart-drawer-subtotal"><span class="cart-drawer-subtotal-label">Subtotal:</span>' +
              '<div class="cart-drawer-subtotal-prices" data-cart-subtotal><span class="cart-drawer-subtotal-current">$0.00</span></div></div>' +
            '<button type="button" class="cart-drawer-checkout" data-cart-checkout>' +
              '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4 4h1l1.2 6.2a1 1 0 0 0 1 .8h5.2a1 1 0 0 0 1-.8L14 6H5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="7" cy="13" r="1" fill="currentColor"/><circle cx="12" cy="13" r="1" fill="currentColor"/></svg>' +
              'Checkout</button>' +
            '<button type="button" class="cart-drawer-continue cart-drawer-continue--footer" data-cart-close>Continue shopping</button>' +
          '</footer>' +
        '</aside>' +
      '</div>' +
      '<script type="application/json" id="cart-upsell-data">[{"id":"perform","title":"Call to Perform Strips","price":"$25.00","image":"' + base + 'brand-perform.png","url":"#"},{"id":"connect","title":"Call to Connect Strips","price":"$25.00","image":"' + base + 'brand-connect.png","url":"#"},{"id":"relax","title":"Call to Relax Strips","price":"$25.00","image":"' + base + 'brand-relax.png","url":"#"}]<\/script>';

    var drawer = root.firstElementChild;
    document.body.appendChild(drawer);
    document.body.appendChild(root.querySelector('#cart-upsell-data'));
    return drawer;
  }

  function showEmailLandingSuccess(form) {
    if (!form) return;

    var landing = document.querySelector('[data-email-landing]');
    var flow = form.querySelector('[data-email-landing-flow]');
    var success = form.querySelector('[data-email-landing-success]');
    var copy = landing && landing.querySelector('.email-landing-copy');

    if (flow) flow.hidden = true;
    if (success) {
      success.hidden = false;
      success.removeAttribute('hidden');
    }
    if (copy) copy.classList.add('email-landing-copy--success');
    if (landing) landing.classList.add('email-landing--submitted');
  }

  function emailLandingPostedFromUrl() {
    var search = window.location.search;
    var hash = window.location.hash;
    return (
      search.indexOf('customer_posted=true') !== -1 ||
      search.indexOf('contact_posted=true') !== -1 ||
      hash.indexOf('contact_form') !== -1 ||
      hash.indexOf('email-landing-form') !== -1
    );
  }

  function markEmailLandingSubmitted() {
    try {
      sessionStorage.setItem('theCallWaitlistSuccess', '1');
    } catch (error) {}
  }

  function consumeEmailLandingSubmittedFlag() {
    try {
      if (sessionStorage.getItem('theCallWaitlistSuccess') === '1') {
        sessionStorage.removeItem('theCallWaitlistSuccess');
        return true;
      }
    } catch (error) {}
    return false;
  }

  function cleanEmailLandingSuccessUrl() {
    if (!emailLandingPostedFromUrl()) return;
    history.replaceState(null, '', window.location.pathname);
  }

  function initEmailLandingSteps() {
    var root = document.querySelector('[data-email-landing-steps]');
    if (!root) return;

    var form = root.closest('form');
    var intro = document.querySelector('[data-email-intro]');
    var nameStage = document.querySelector('[data-email-name-stage]');
    var landing = document.querySelector('[data-email-landing]');
    var emailInput = root.querySelector('#email-landing-input');
    var nameInput = document.querySelector('#email-landing-name');
    var nextBtn = root.querySelector('[data-email-step-next]');
    var tagsSync = form.querySelector('#email-landing-tags-sync');
    var emailField = form.querySelector('#email-landing-email-field');
    var firstNameField = form.querySelector('#email-landing-first-name-field');
    var nameNoteField = form.querySelector('#email-landing-name-note-field');
    var marketingConsent = form.querySelector('[data-email-marketing-consent]');
    var marketingField = form.querySelector('#email-landing-accepts-marketing-field');
    var submitBtn = form.querySelector('[data-email-name-submit]');
    if (!emailInput || !nextBtn || !form || !nameStage || !emailField || !firstNameField || !nameNoteField || !marketingConsent || !marketingField) return;

    if (marketingConsent.checked) {
      marketingField.value = 'true';
    }

    var emailError = form.querySelector('[data-email-field-error="email"]');
    var nameError = form.querySelector('[data-email-field-error="name"]');
    var consentError = form.querySelector('[data-email-field-error="consent"]');

    function syncSignupFields() {
      var email = emailInput.value.trim();
      var name = nameInput ? nameInput.value.trim() : '';

      emailField.value = email;
      firstNameField.value = name;
      nameNoteField.value = name;

      if (tagsSync) {
        tagsSync.value = name
          ? 'prospect,waitlist,landing,the-call,name-' + name.replace(/,/g, ' ').replace(/\s+/g, '-')
          : 'prospect,waitlist,landing,the-call';
      }
    }

    function clearFieldError(input, errorEl) {
      if (!input || !errorEl) return;
      input.classList.remove('is-invalid');
      input.removeAttribute('aria-invalid');
      errorEl.textContent = '';
      errorEl.hidden = true;
    }

    function showFieldError(input, errorEl, message) {
      if (!input || !errorEl) return false;
      input.classList.add('is-invalid');
      input.setAttribute('aria-invalid', 'true');
      errorEl.textContent = message;
      errorEl.hidden = false;
      input.focus();
      return false;
    }

    function validateEmailField() {
      var value = emailInput.value.trim();
      if (!value) {
        clearFieldError(emailInput, emailError);
        emailInput.focus();
        return false;
      }
      if (!emailInput.checkValidity()) {
        return showFieldError(emailInput, emailError, 'That email looks off.');
      }
      clearFieldError(emailInput, emailError);
      return true;
    }

    function validateNameField() {
      if (!nameInput) return true;
      var value = nameInput.value.trim();
      if (!value) {
        return showFieldError(nameInput, nameError, 'Enter your name.');
      }
      clearFieldError(nameInput, nameError);
      return true;
    }

    function validateConsentField() {
      if (marketingConsent.checked) {
        if (consentError) {
          consentError.textContent = '';
          consentError.hidden = true;
        }
        marketingConsent.classList.remove('is-invalid');
        marketingConsent.removeAttribute('aria-invalid');
        marketingField.value = 'true';
        return true;
      }

      marketingField.value = '';
      marketingConsent.classList.add('is-invalid');
      marketingConsent.setAttribute('aria-invalid', 'true');
      if (consentError) {
        consentError.textContent = 'Please agree to receive emails before continuing.';
        consentError.hidden = false;
      }
      marketingConsent.focus();
      return false;
    }

    emailInput.addEventListener('input', function () {
      clearFieldError(emailInput, emailError);
    });

    if (nameInput) {
      nameInput.addEventListener('input', function () {
        clearFieldError(nameInput, nameError);
        syncSignupFields();
      });
    }

    if (marketingConsent) {
      marketingConsent.addEventListener('change', function () {
        if (marketingConsent.checked) {
          marketingConsent.classList.remove('is-invalid');
          marketingConsent.removeAttribute('aria-invalid');
          if (consentError) {
            consentError.textContent = '';
            consentError.hidden = true;
          }
        }
      });
    }

    function showStep(step) {
      var isNameStep = step === 2;
      if (intro) intro.hidden = isNameStep;
      nameStage.hidden = !isNameStep;
      if (landing) landing.classList.toggle('email-landing--name-step', isNameStep);
      if (isNameStep) {
        syncSignupFields();
        if (nameInput) {
          window.setTimeout(function () {
            nameInput.focus();
          }, 180);
        }
      }
    }

    if (form.querySelector('.email-landing-errors')) {
      if (emailInput.value) {
        syncSignupFields();
        showStep(2);
      } else {
        showStep(1);
      }
    }

    emailInput.addEventListener('change', syncSignupFields);

    nextBtn.addEventListener('click', function () {
      if (!validateEmailField()) return;
      syncSignupFields();
      showStep(2);
    });

    if (nameInput) {
      nameInput.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        if (!nameStage.hidden && !validateNameField()) return;
        if (!nameStage.hidden && !validateConsentField()) return;
        if (nameStage.hidden) return;
        var submitBtn = form.querySelector('[data-email-name-submit]');
        if (submitBtn && typeof form.requestSubmit === 'function') {
          form.requestSubmit(submitBtn);
        } else if (submitBtn) {
          submitBtn.click();
        } else {
          form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
      });
    }

    form.addEventListener('submit', function (event) {
      var nameStageVisible = nameStage && !nameStage.hidden;
      if (!nameStageVisible) {
        event.preventDefault();
        return;
      }

      if (nameInput && !validateNameField()) {
        event.preventDefault();
        return;
      }

      if (!validateConsentField()) {
        event.preventDefault();
        return;
      }

      syncSignupFields();
    });
  }

  function initEmailLandingSuccessGuard() {
    var form = document.querySelector('#email-landing-form');
    if (!form) return;

    if (form.querySelector('.email-landing-errors')) {
      try {
        sessionStorage.removeItem('theCallWaitlistSuccess');
      } catch (error) {}
      return;
    }

    var success = form.querySelector('[data-email-landing-success]');
    var posted =
      (success && !success.hidden) ||
      consumeEmailLandingSubmittedFlag() ||
      emailLandingPostedFromUrl();

    if (posted) {
      showEmailLandingSuccess(form);
      cleanEmailLandingSuccessUrl();
    }
  }

  function assetBaseForPreview() {
    return window.TheCallAssetBase || 'assets/';
  }

  function initEmailLandingUrl() {
    if (!document.body.classList.contains('template-landing')) return;
    if (window.location.pathname === '/password') {
      var nextUrl = '/';
      if (window.location.search) {
        nextUrl += window.location.search;
      }
      history.replaceState(null, '', nextUrl);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initEmailLandingUrl();
    initEmailLandingSuccessGuard();
    initSmoothScroll();
    initNavStatesBg();
    initFaqAccordion();
    initSocialGallery();
    initProductGallery();
    initProductPage();
    initHeroHeadlineCycle();
    initCartDrawer();
    initPasswordProductLinks();
    initEmailLandingSteps();
  });
})();
